/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Swap_Row_LevelInputs */

const en_us2_swap_row_level = /** @type {(inputs: Swap_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Level`)
};

const pt_br2_swap_row_level = /** @type {(inputs: Swap_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const es_419_swap_row_level = /** @type {(inputs: Swap_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel`)
};

const pt_pt2_swap_row_level = /** @type {(inputs: Swap_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nível`)
};

const fr_fr2_swap_row_level = /** @type {(inputs: Swap_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau`)
};

const de_de2_swap_row_level = /** @type {(inputs: Swap_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stufe`)
};

const it_it2_swap_row_level = /** @type {(inputs: Swap_Row_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livello`)
};

/**
* | output |
* | --- |
* | "Level" |
*
* @param {Swap_Row_LevelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_row_level = /** @type {((inputs?: Swap_Row_LevelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_Row_LevelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_row_level(inputs)
	if (locale === "es-419") return es_419_swap_row_level(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_row_level(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_row_level(inputs)
	if (locale === "de-DE") return de_de2_swap_row_level(inputs)
	if (locale === "it-IT") return it_it2_swap_row_level(inputs)
	return en_us2_swap_row_level(inputs)
});
export { swap_row_level as "swap.row_level" }